import { DemoBatchJobsTable } from '@/pages/demo/components/DemoBatchJobsTable';

export const DemoBatchJobsPage = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-semibold">배치 OCR Job</h1>
      <p className="text-muted-foreground">Document AI 배치 OCR job 목록·삭제·상세 조회</p>
    </div>
    <DemoBatchJobsTable />
  </div>
);
